import {
  Checkbox,
  Chip,
  ListItem,
  ListItemIcon,
  ListItemSecondaryAction,
  ListItemText,
} from "@material-ui/core";
import React from "react";
import { useHistory, useLocation } from "react-router-dom";
import { RecipientOrg } from "../../../domain/RecipientsViewModel";

export type RecipientsItemProps = {
  recipientOrg: RecipientOrg;
  toggleSelectRecipient: (recipient: RecipientOrg) => void;
};

export const RecipientsItem: React.FC<RecipientsItemProps> = ({
  recipientOrg,
  toggleSelectRecipient,
}) => {
  const { pathname } = useLocation();
  const history = useHistory();

  const navigate = (id: string) => history.push(`${pathname}/${id}`);

  return (
    <ListItem
      alignItems="flex-start"
      data-test="row"
      ContainerComponent="div"
      button
      onClick={() => navigate(recipientOrg.id)}
    >
      <ListItemIcon>
        <Checkbox
          edge="start"
          checked={recipientOrg.isSelected || false}
          onChange={() => toggleSelectRecipient(recipientOrg)}
          onClick={(e) => e.stopPropagation()}
          data-test="select-individual-ao-checkbox"
        />
      </ListItemIcon>
      <ListItemText
        primary={recipientOrg.name || `Organisation ${recipientOrg.id}`}
        secondary={
          <>
            <b>Status:</b> {recipientOrg.status}
          </>
        }
      />
      <ListItemSecondaryAction>
        <Chip
          size="small"
          label={
            "Assigned to: " +
            (recipientOrg.assignedToDisplayName || "Unassigned")
          }
        />
      </ListItemSecondaryAction>
    </ListItem>
  );
};
